<template>
  <div class="trainingRecord">
    <div style="padding:10px 0px 10px 5px">
      <el-button type="primary" @click="downTempe">下载模板</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="序号" align="center" width="50" fixed>
        <template slot-scope="scope">
          <span>{{(paging.page - 1) * paging.limit + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column label="测试班名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.test_class_title}}</span>
        </template>
      </el-table-column>
      <el-table-column label="机构" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.mechanism_fullName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="工作时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.test_start_time |dateformat("YYYY-MM-DD HH:mm")}}</span>
          至
          <span>{{ scope.row.test_end_time |dateformat("YYYY-MM-DD HH:mm")}}</span>
        </template>
      </el-table-column>
      <el-table-column label="等级" align="center" width="150">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.grade" :key="index">{{item.grade}}&nbsp;&nbsp;</span>
        </template>
      </el-table-column>
      <el-table-column label="是否考评组长" align="center" width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.isleader == '是'?'是':'否'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="考评员" align="center" width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.evaluator_rank|rank}}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120" align="center">
        <template slot-scope="scope">
          <div style="display:flex;justify-content: center;position: relative;">
            <el-button
              @click="downLoad(scope.row)"
              type="text"
              size="small"
              style="margin-right:10px;"
              v-if="scope.row.isHasAttachments"
              :disabled="proDisabled"
            >下载</el-button>
            <el-upload
              class="upload-demo"
              action="#"
              ref="upload"
              :on-change="beforeAvatarUpload"
              :show-file-list="false"
              :auto-upload="false"
              :disabled="scope.row.isHasAttachments"
            >
              <div  v-if="!scope.row.isHasAttachments">
                <el-button
                  size="small"
                  type="text"
                  @click="upLoad(scope.row)"
                  style="margin:10px;"
                  v-if="((scope.row.grade_submission_status==1 || scope.row.grade_submission_status==3 || scope.row.grade_submission_status==4) && scope.row.isleader =='是')"
                >上传</el-button>
              </div>

              <el-button
                size="small"
                type="text"
                :disabled="scope.row.isHasAttachments"
                v-if="scope.row.isHasAttachments"
              >已上传</el-button>
            </el-upload>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="提示" :visible.sync="importDialog" width="20%">
      <span style="font-size:16px;color:#f56c6c;">监督表提交后不可修改，是否提交？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sumitWord">提交</el-button>
        <el-button type="primary" @click="cancel">取消</el-button>
      </span>
    </el-dialog>
    <div class="pagination" style="margin-top: 55px;text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount > 10"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetWorkRecordList,
  UploadTestClassAttachments,
  DownloadAttachments
} from "@/api/admin/appraiser.js";
import { saveFileToLink } from "@/util/download.js";
// import { setTimeout } from "timers";
export default {
  data() {
    return {
      tableData: [],
      totalCount: 0,
      paging: {
        limit: 10,
        page: 1
      },
      circle: 0,
      // proNone: false,
      proDisabled: false,
      apiUrl: window.apiObj.apiUrl,
      tempUrl: "",
      dataRow: {},
      importDialog: false,
      file: ""
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      GetWorkRecordList(Object.assign(this.paging)).then(data => {

        let list = data.data.result;
        this.totalCount = list.totalCount;
        if (list.items.length > 0) {
          this.tableData = list.items;
          this.tempUrl = list.url;
        }
      });
    },
    handleCurrentChange(page) {
      this.paging.page = page;
      this.getList();
    },
    downLoad(row) {
      this.proDisabled = true;
      DownloadAttachments({ id: row.id })
        .then(data => {

          if (data.data.success) {
            const onProgress = progress => {
              window.console.log("progress====", progress);
            };
            const url = this.apiUrl + data.data.result;

            // const Business = data.data.result.split("/");
            // const name = this.splitFileName(Business[Business.length - 1]);
            const name = "监督表";
            saveFileToLink(url, name, "", onProgress);
          }
          this.proDisabled = false;
        })
        .catch(() => {
          this.proDisabled = false;
        });
    },
    upLoad(row) {
      this.dataRow = row;
    },
    downTempe() {
      const onProgress = progress => {
        //window.console.log("progress====", progress);
      };
      const url = this.apiUrl + this.tempUrl;
      // const Business = this.tempUrl.split("/");
      // const name = this.splitFileName(Business[Business.length - 1]);
      const name = "监督表模板";
      saveFileToLink(url, name, "", onProgress);
    },
    beforeAvatarUpload(file) {
      this.importDialog = true;
      this.file = file.raw;
    },
    sumitWord() {
      this.importDialog = false;
      UploadTestClassAttachments({
        id: this.dataRow.id,
        file: this.file,
        isFormSubmit: true
      })
        .then(data => {

          if (data.data.result) {
            if (data.data.result.isSuccess) {
              this.$message({
                message: data.data.result.errorMsg,
                type: "success"
              });
              this.getList();
            } else {
              //this.$message.error("上传失败");
              this.$message.error(data.data.result.errorMsg);
            }
          }
          // setTimeout(() => {
          //   this.proNone = false;
          // }, 1000);
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.proNone = false;
          // }, 1000);
        });
    },
    cancel() {
      this.importDialog = false;
    },
    splitFileName(text) {
      var pattern = /\.{1}[a-z]{1,}$/;
      if (pattern.exec(text) !== null) {
        return text.slice(0, pattern.exec(text).index);
      } else {
        return text;
      }
    }
  },
  filters: {
    rank: data => {
      switch (data) {
        case "1":
          return "一级考评员";
        case "2":
          return "二级考评员";
        case "3":
          return "三级考评员";
      }
    }
  }
};
</script>

<style lang="less">
.trainingRecord {
  .progress {
    position: absolute;
    bottom: 0px;
    right: -9px;
    .el-progress-circle {
      width: 33px !important;
      height: 33px !important;
    }
  }
}
</style>
